export default {
  props: {
    tag: {
      type: String,
    },

    title: {
      type: String,
    },

    description: {
      type: String,
    },

    list: {
      type: Array,
    },

    button: {
      type: Object,
    },

    textAlternative: {
      type: String,
    },
  },
}
